<template>
  <div class="sql-instanceInfo-page">
    <Card>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}" icon="md-refresh">刷新</Button>
        </i-col>
      </Row>
      <Divider />
      <Row :gutter="24">
        <!--<i-col :xs="12" :md="8" :lg="4" style="height: 120px;padding-bottom: 10px;">-->
          <!--<Card>-->
            <!--<div>-->
              <!--<h5>服务器: {{this.$route.params.host}}</h5>-->
              <!--<h5>端口 :{{this.$route.params.port}}</h5>-->
              <!--<h5>所属环境: {{this.$route.params.env}}</h5>-->
              <!--<h5>维护人员: {{this.$route.params.ops_user}}</h5>-->
            <!--</div>-->
          <!--</Card>-->
        <!--</i-col>-->
        <i-col :xs="12" :md="8" :xl="4" v-for="(infor, i) in inforCardData" :key="`infor-${i}`"
               style="height: 120px;padding-bottom: 10px;">
          <infor-card shadow :color="infor.color" :icon="infor.icon" :icon-size="36">
            <span style="font-size: 35px"><count-to :end="infor.count" count-class="count-style"/></span>
            <p>{{ infor.title }}</p>
          </infor-card>
        </i-col>
      </Row>
      <tables ref="instanceInfoTable" height="500" search-place="top" v-model="processData" :columns="processColumns"/>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import {getProcessList, getInstanceStats} from '@/api/sqlserver'

export default {
  name: 'sqlserverInstanceInfo',
  components: {
    Tables,
    InforCard,
    CountTo
  },
  data: function () {
    return {
      infoTmpData: [
        {title: '', icon: 'md-people', count: 0, color: '#2d8cf0'},
        {title: '', icon: 'md-bicycle', count: 0, color: '#19be6b'},
        {title: '', icon: 'md-alarm', count: 0, color: '#ff9900'},
        {title: '', icon: 'md-speedometer', count: 0, color: '#ed3f14'},
        {title: '', icon: 'md-alarm', count: 0, color: '#E46CBB'},
        {title: '', icon: 'md-speedometer', count: 0, color: '#9A66E4'}
      ],
      inforCardData: [],
      searchForm: {
        name: ''
      },
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      processColumns: [
        {
          title: 'ID',
          key: 'PROCESS_ID',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'top',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleProcessDelete(params.row.PROCESS_ID)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'text',
                      shape: 'circle'
                    }
                  }, [
                    h('div', 'KILL ' + params.row.PROCESS_ID)
                  ])
                ])
              ])
            }
          }
        },
        {title: 'USER', key: 'USER', align: 'center', minWidth: 150},
        {title: 'HOST', key: 'HOST', align: 'center', minWidth: 150},
        {title: 'DB', key: 'DB', align: 'center', minWidth: 150},
        {title: 'COMMAND', key: 'COMMAND', align: 'center', minWidth: 100},
        {title: 'TIME', key: 'TIME', align: 'center', minWidth: 80},
        {title: 'STATE', key: 'STATE', align: 'center', minWidth: 150},
        {title: 'INFO', key: 'INFO', tooltip: true, align: 'center', minWidth: 150}
      ],
      processData: []
    }
  },
  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.getProcess()
    },
    refresh () {
      this.getStats()
      this.getProcess()
    },
    getProcess () {
      let params = {
        id: this.$route.query.id
      }
      getProcessList(params).then(res => {
        this.processData = res.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取进程列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取进程列表失败！服务器无响应'
          })
        }
      })
    },
    handleProcessDelete (processID) {
      let params = {
        id: this.$route.query.id,
        process_id: processID
      }
      getProcessList(params).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getProcess()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
        this.getProcess()
      })
    },
    getStats () {
      let params = {
        id: this.$route.query.id
      }
      this.inforCardData = this.infoTmpData
      getInstanceStats(params).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            this.inforCardData[i].title = result[i].key
            this.inforCardData[i].count = result[i].value
          }
        } else {
          this.$Notice.error({
            title: '获取统计信息失败'
          })
        }
      })
    }
  },

  mounted: function () {
    this.getStats()
    this.getProcess()
  }
}
</script>
<style lang="less">
  .sql-instanceInfo-page{
    .ivu-card-shadow{
        box-shadow: 0 0px 1px 1px rgba(0, 0, 0, 0.1);
    }
    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item{
      padding: 8px 16px;
    }
    @media screen and (min-width:1600px) {
      .ivu-col-span-md-8{
        width:16.66666666666667%;
      }
    }
    @media screen and (max-width:640px) {
      h1{
        font-size: 1.5em;
      }
      .ivu-table-wrapper,.ivu-table-body{
        height:auto!important;
      }
      .ivu-divider-horizontal{
          margin: 0px 0 15px;
      }
    }
  }
</style>
